import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import {
  getCommunityVideoMaxMetric,
  getFeedsComments,
  getFeedsMaxMetric,
} from '@op/services';
import { useUpdateEffect } from 'ahooks';
import { useState, useEffect, useCallback, useMemo, useContext } from 'react';
import { AppContext } from '../../RealtimeOpinions/pages/KeyMetricsOverview/context';

interface UseTrendingRequestParams {
  filter: any;
  sortBy?: any;
  extraFilter?: any;
  type: string;
  requestMax?: boolean;
}

export const useTrendingRequest = ({
  type,
  filter,
  sortBy,
  extraFilter,
  requestMax = true,
}: UseTrendingRequestParams) => {
  // const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({ list: [], statistics: {}, total: 0 });
  const [error, setError] = useState(false);

  const { wrapperRequestTile, loading: maxLoading } = useCancelRequestHook({
    defaultLoading: requestMax,
  });
  const {
    wrapperRequestTile: wrapperRequestTileComments,
    loading: commentsLoading,
  } = useCancelRequestHook({
    clear: () => setData({ list: [], statistics: {}, total: 0 }),
    defaultLoading: true,
  });

  const { refresh, refreshTime } = useContext(AppContext);
  const fetchData = useCallback(
    (noLoading = false) => {
      if (!filter?.edition_unified_id) return;
      // setData({ list: [], statistics: {}, total: 0 });

      let sort_item = 'comment_time';
      let sort_model = 'desc';

      if (sortBy) {
        const { by, order } = sortBy || {};
        sort_item = by;
        sort_model = order;
      }

      const params = {
        ...filter,
        page: 1,
        page_size: 50,
        sort_item,
        sort_model,
        ...(extraFilter && Object.keys(extraFilter || {}).length > 0
          ? { ...extraFilter }
          : {}),
      };
      const requestList = [
        wrapperRequestTileComments(
          getFeedsComments,
          params,
          noLoading,
          refreshTime,
        ),
      ];

      if (requestMax) {
        const requestMaxFunc =
          type === 'feeds'
            ? wrapperRequestTile(getFeedsMaxMetric, params, noLoading)
            : wrapperRequestTile(getCommunityVideoMaxMetric, params, noLoading);
        requestList.push(requestMaxFunc);
      }
      Promise.all(requestList)
        .then(([tableList, totalInfo = []]) => {
          if (tableList) {
            const newData = {
              ...tableList,
              list: Array.isArray(tableList.list) ? tableList.list : [],
            };
            setData({
              list: newData.list,
              statistics: totalInfo.length > 0 ? totalInfo[0] : {},
              total: newData?.list?.length || 0,
            });
            setError(false);
          } else {
            setData({ list: [], statistics: {}, total: 0 });
            setError(true);
          }
        })
        .catch(() => {
          setError(true);
        });
    },
    [filter, sortBy],
  );

  const loading = useMemo(() => {
    return maxLoading || commentsLoading;
  }, [maxLoading, commentsLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useUpdateEffect(() => {
    fetchData(true);
  }, [refresh]);

  return { data, loading, error, refetch: fetchData };
};
